module.exports = __webpack_public_path__ + "img/badge_outlined.4862e1a4.svg";